import firebase from 'firebase';

// Initialize Firebase
// var config = {
//     apiKey: "AIzaSyCkB-bW5_beElbEWyN3miha9Brx0dPwnzg",
//     authDomain: "youcandoit-8dbb9.firebaseapp.com",
//     databaseURL: "https://youcandoit-8dbb9.firebaseio.com",
//     projectId: "youcandoit-8dbb9",
//     storageBucket: "",
//     messagingSenderId: "62711312744"
// };
// firebase.initializeApp(config);

// // Initialize Firebase
// var config = {
//     apiKey: "AIzaSyCkB-bW5_beElbEWyN3miha9Brx0dPwnzg",
//     authDomain: "youcandoit-8dbb9.firebaseapp.com",
//     databaseURL: "https://youcandoit-8dbb9.firebaseio.com",
//     projectId: "youcandoit-8dbb9",
//     storageBucket: "youcandoit-8dbb9.appspot.com",
//     messagingSenderId: "62711312744"
// };
// firebase.initializeApp(config);

// Initialize Firebase
var config = {
    apiKey: "AIzaSyCp-nhLl96XtWEMLVvl-1jMxEZTeKR9qNo",
    authDomain: "angstel-56355.firebaseapp.com",
    databaseURL: "https://angstel-56355.firebaseio.com",
    projectId: "angstel-56355",
    storageBucket: "angstel-56355.appspot.com",
    messagingSenderId: "197541219771"
};
firebase.initializeApp(config);

export default firebase;
